import { Accordion } from '@/domains/retention/Footer/modules/Accordion/Accordion';

import { footerContactCountryTitle } from '../../translations';
import { Flags } from './Flags';

export const International = () => (
  <div
    className={`mt-m border-t border-solid border-foundation-inverted pt-l
      desktop:mt-0 desktop:border-0`}
  >
    <Accordion title={footerContactCountryTitle} isExpandable={false}>
      <Flags />
    </Accordion>
  </div>
);

International.displayName = 'International';
